import {
  VKHandler,
  YandexHandler,
  OKHandler,
  GithubHandler,
  TBankHandler,
  AppleHandler,
  AlfaHandler,
  AlfaWebviewHandler,
} from 'src/routes/SocialAuthRedirectHandles/handlers';
import { flow, split, last } from 'lodash/fp';

/**
 * @desc метод для обработки редиректов из соц сетек.
 * при необходимости добавить новую соц сеть которая возвращает код в редиректе,
 * создать новый обработчик и шаблон в app/views/social_login/{имя соц сети}.haml
 * */
export default (): void => {
  const { pathname } = window.location;

  // Проверяем, заканчивается ли путь на /alfabank/webview
  if (pathname.endsWith('/alfabank/webview')) {
    AlfaWebviewHandler();
    return;
  }
  /** название соответствует шаблону app/views/social_login/vkontakte.haml */
  const socialName = flow(split('/'), last)(window.location.pathname);

  switch (socialName) {
    case 'vkontakte': {
      VKHandler();
      break;
    }
    case 'yandex': {
      YandexHandler();
      break;
    }
    case 'ok': {
      OKHandler();
      break;
    }
    case 'github': {
      GithubHandler();
      break;
    }
    case 'tbank': {
      TBankHandler();
      break;
    }
    case 'apple': {
      AppleHandler();
      break;
    }
    case 'alfabank': {
      AlfaHandler();
      break;
    }
    default: {
      alert(`handler for "${socialName}" not found`);
    }
  }
};
